import DarkLogo from '@static/images/brand/logo-dark.svg';
import LightLogo from '@static/images/brand/logo-light.svg';
import { useThemeStore } from '@terminal/components/theme-controller/stores/useThemeStore';
import { isDarkTheme } from '@terminal/components/theme-controller/utils/theme-utils/theme-utils';
import React, { SVGProps } from 'react';

type ToggleBrandLogoProps = SVGProps<SVGSVGElement> & {
  alt?: string;
  title?: string;
};

export const ToggleBrandLogo = (props: ToggleBrandLogoProps) => {
  const themeName = useThemeStore(state => state.themeName);
  const ThemedLogo = isDarkTheme(themeName) ? DarkLogo : LightLogo;

  return <ThemedLogo {...props} />;
};
